import inputData from "data/input";
import selectionsData from "data/selections";

const {
    editDistributionTypes: editDistributionTypesKey,
} = selectionsData.keys;

const { editDistributionType: editDistributionTypeName } = inputData.names;

const { autoComplete: autoCompleteInputType } = inputData.types;

const { editDistributionType: editDistributionTypeInputLabel } = inputData.labels;

const editDistributionFormData = [
    {
        col: { xs: 12 },
        label: editDistributionTypeInputLabel,
        name: editDistributionTypeName,
        selectionKey: editDistributionTypesKey,
        type: autoCompleteInputType,
    },
];

export default editDistributionFormData;
